var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgApproved = function SvgApproved(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solid/16*16/informative/approved"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 14.7743C11.6818 14.7743 14.6666 11.7895 14.6666 8.10758C14.6666 4.42569 11.6818 1.44092 7.99992 1.44092C4.31802 1.44092 1.33325 4.42569 1.33325 8.10758C1.33325 11.7895 4.31802 14.7743 7.99992 14.7743ZM11.0613 6.41458C11.2308 6.1966 11.1915 5.88247 10.9736 5.71293C10.7556 5.5434 10.4414 5.58266 10.2719 5.80064L7.60058 9.23521C7.54118 9.31158 7.42944 9.32149 7.35753 9.25677L5.66774 7.73596C5.46248 7.55123 5.14634 7.56787 4.96161 7.77313C4.77688 7.97838 4.79352 8.29453 4.99877 8.47925L6.68856 10.0001C7.19198 10.4531 7.97412 10.3838 8.38993 9.84915L11.0613 6.41458Z",
    fill: "#389E0D"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgApproved);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "approved.ccd0cac823c02024f1cbf07f9f6918fa.svg";